module.exports = __webpack_public_path__ + "static/media/instrukcja_monkey.6f8c9bac.gif";